// extracted by mini-css-extract-plugin
export default {"wrapper":"src-components-JobBoard-JobFilterChipList-JobFilterChipList---wrapper---nVTk8","chip":"src-components-JobBoard-JobFilterChipList-JobFilterChipList---chip---mNoCH"};